import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { track } from '@eventbrite/datalayer-library';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DiscoverBucketCard } from '../../../../components/DiscoverEventCard/DiscoverBucketCard';
import { SEASONAL_FEATURED_MODULE } from '../../../../constants/seasonalModule';
import { ConnectedProps, DiscoverState } from '../../../../types';
import { HOMEPAGE_SEASONAL_VALENTINE } from '../../constants/analytics';
import { SEASONAL_MODULE_DATA } from '../../constants/category';
import './SeasonalModule.scss';

export interface SeasonalModuleProps extends ReduxProps {
    seasonal: string;
}
interface TitleSection {
    seasonal: string;
}

const TitleDescription = React.memo(({ seasonal }: TitleSection) => (
    <div className="title-container">
        <div className="title-subtitle-container">
            <h2>{SEASONAL_FEATURED_MODULE[seasonal].title}</h2>
            {SEASONAL_FEATURED_MODULE[seasonal].subTitle != '' && (
                <h3>{SEASONAL_FEATURED_MODULE[seasonal].subTitle}</h3>
            )}
        </div>
    </div>
));

export const SeasonalModule = ({ location, seasonal }: SeasonalModuleProps) => {
    const [seasonalModuleData, setSeasonalModuleData] =
        useState(SEASONAL_MODULE_DATA);
    const [locationSlug, setLocationSlug] = useState('local');

    React.useEffect(() => {
        if (location && location.currentPlace) {
            track({
                eventName: 'HomepageSeasonalModuleView',
                eventData: {
                    searchLocation: location.currentPlace,
                },
            });
        }
    }, [location]);

    React.useEffect(() => {
        if (location && location.slug) {
            setLocationSlug(location.slug);
        } else {
            setLocationSlug('local');
        }
    }, [location]);

    useEffect(() => {
        if (location && location.currentPlace) {
            setSeasonalModuleData((prevData) => {
                const newData = [...prevData];
                if (location.currentPlace != 'Online') {
                    newData[0].title = 'Love in ' + location.currentPlace;
                } else {
                    newData[0].title = 'Celebrate Love';
                }
                return newData;
            });
        }
    }, [location]);

    return (
        <div className="seasonal-module-buckets" data-testid="seasonal-module">
            <div className="seasonal-featured-container">
                <TitleDescription seasonal={seasonal} />
                <div className="simple-carousel-parent">
                    <SimpleCarousel slidesVisible={{ desktop: 4, tablet: 4 }}>
                        {seasonalModuleData.map((bucket) => (
                            <div
                                className="seasonal-featured-event-card"
                                key={bucket.id}
                            >
                                <DiscoverBucketCard
                                    statsigEventName={
                                        HOMEPAGE_SEASONAL_VALENTINE
                                    }
                                    heapId={`homepage-module-bucket-${bucket.bucketUrl}`}
                                    bucketUrl={`b/${locationSlug}/seasonal/?bucket=${bucket.bucketUrl}`}
                                    imgSrc={bucket.imgSrc}
                                    title={bucket.title}
                                    description={bucket.description}
                                />
                            </div>
                        ))}
                    </SimpleCarousel>
                </div>
            </div>
        </div>
    );
};

const _mapStateToProps = ({ user, location }: DiscoverState) => {
    return {
        isAuthenticated: user.isAuthenticated,
        location: location,
    };
};

type ReduxProps = ConnectedProps<typeof _mapStateToProps>;
export default connect(_mapStateToProps)(SeasonalModule);
